<template>
  <div class="comContent"> 
    <myTable :index="index" :selection="false" :page="page" :showpage="false" :operation="false" :table-data="tableData"
      :table-option.sync="tableOption" @page-change="getList" :expand="false">
      <template slot="operation" slot-scope="scope" v-if="scope.row.shopBusinessStatus != 2">
        <div class="linkView"> 
          <el-link type="primary" :underline="false" @click="setting(scope.row)" style="margin-right: 10px">
           管理
          </el-link>
        </div>
      </template>
    </myTable> 
  </div>
</template>
<script> 
import myTable from "@/components/myTable";
import _ from "lodash";
import {
 orgConfigSbList
} from "@/api/invoiceOps";

export default {
  components: {  myTable },
  props: {},
  data () {
    return {
      form: {
       
      }, 
      operation: false,
      selection: true,
      index: true,
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      searchData:{},
      tableOption: [  
        { label: "省办", prop: "orgName" }, 
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 150,
          align: "center", 
        }, 
      ], 
    };
  },
  filters: {},
  created () { },
  mounted () { 
    const { tab, status } = this.$route.query 
    this.getList(1);
  },
  methods: {
    setting (row) {
      this.$router.push({
        path: "./invoiceCenter-invoiceDigitConfigChildren",
        query: {
          orgCode: row.orgCode 
        },
      });
    },    
    getList (current) {
      const params = Object.assign({}, this.searchData); 
      orgConfigSbList(params).then((data) => {
        if (data) {
          this.tableData = data; 
        } else {
          this.tableData = []; 
        }
      });
    }, 
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  height: calc(100% - 8px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 18px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 18px) !important;
  overflow-y: scroll !important;
}

.linkView {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .el-link {
    margin: 5px;
  }
}
</style>
